import { clearAuthStorage } from '../../helpers';
import { getLogoutURL } from '../../services/login.service';

export const redirectToLogout = (): void => {
    document.getElementById('root').classList.value = 'd-none'; // Safari fix to wipe page visibility due to page caching
    clearAuthStorage();
    getLogoutURL().then((response) => {
        globalThis.location.href = response.url;
    });
};

export const updateSession = (userId: string): void => {
    sessionStorage.setItem('userId', userId);
    sessionStorage.setItem('selectedFolderId', undefined);
};
